import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UniqueEntityID } from '@/domain/core'
import { UseCase } from '@/domain/core/UseCase'
import { Result } from '@/domain/protocols/Result'

import type { IUserChartsWebClient } from '@/infra/http/UserChartsWebClient/IUserChartsWebClient'

export class DownloadUserChartOriginalUseCase implements UseCase<UniqueEntityID, Promise<Result<Blob>>> {
  private webClient: IUserChartsWebClient

  constructor(webClient?: IUserChartsWebClient) {
    if (webClient) {
      this.webClient = webClient
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.webClient = container.get<IUserChartsWebClient>(InjectionTokens.UserChartsWebClient)
  }

  async execute(chartId: UniqueEntityID): Promise<Result<Blob>> {
    try {
      return await this.webClient.downloadOriginal(chartId.toString())
    } catch (error) {
      return Result.fail(error)
    }
  }
}
